import { render } from "./UpgradeModal.vue?vue&type=template&id=26132b21"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__